import { Layout } from '@/components/Layout/Layout';
import ClientSupportPage from 'components/PageLevelComponents/ClientSupportPage';
import { ANONYMOUS_TOKEN_NAME, LOCALE_DEFAULT } from 'config/config';
import type { GetServerSideProps } from 'next';
import { SupportPageController } from 'server/controller/page/support/supportPageController';
import type { ISupportPageResource } from 'server/resource/page/supportPageResource';

const RootPage = (props: ISupportPageResource) => {
  const {
    metaData,
    data,
    searchItemLabels,
    recipeCopy,
    breadcrumbsCMSData,
    footerNavData,
    footerImage,
    locale,
    searchOverlayData,
    countrySelectorData,
    newsletterData,
    contactUsUrl,
    difficultyCopy,
    getHeaderNav,
    getMobileNavData,
    popularSearchData,
    cardCarouselCMSData,
    recallData,
    pathTranslations,
    userToken,
    globalDictionary,
  } = props;

  return (
    <Layout
      themeName={data?.genericPages.at(0)?.theme || ''}
      pathTranslations={pathTranslations}
      locale={locale}
      globalMetadata={metaData}
      getHeaderNav={getHeaderNav}
      getMobileNavData={getMobileNavData}
      popularSearchData={popularSearchData}
      footerNavData={footerNavData}
      footerImage={footerImage}
      searchOverlayData={searchOverlayData}
      countrySelectorData={countrySelectorData}
      newsletterData={newsletterData}
      contactUsUrl={contactUsUrl}
      difficultyCopy={difficultyCopy as Record<string, string>}
      cardCarouselCMSData={cardCarouselCMSData}
      recallData={recallData}
      userToken={userToken}
      globalDictionary={globalDictionary}
    >
      <ClientSupportPage
        data={data}
        breadcrumbsCMSData={breadcrumbsCMSData}
        globalMetadata={metaData}
        searchItemLabels={searchItemLabels as Record<string, string>}
        searchOverlayData={searchOverlayData}
        difficultyCopy={difficultyCopy as Record<string, string>}
        recipeCopy={recipeCopy}
      />
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  params,
  defaultLocale,
  resolvedUrl,
  req,
}) => {
  const anonymousToken = req.cookies[ANONYMOUS_TOKEN_NAME];
  return SupportPageController.getCachedSupportPageData({
    resolvedUrl,
    locale: locale || defaultLocale || LOCALE_DEFAULT,
    slug: Array.isArray(params?.slug) ? params.slug : [],
    userToken: anonymousToken ?? '',
  });
};

export default RootPage;
